import React from 'react'
import { twMerge } from 'tailwind-merge'

type TypographyProps = {
  children: React.ReactNode
  className?: string
}

/**
 * Large hero / page titles
 */
export const H1 = ({ children, className }: TypographyProps) => {
  return (
    <h1
      className={twMerge(
        'font-inter text-4xl md:text-6xl font-light tracking-tight text-gray-900',
        className
      )}
    >
      {children}
    </h1>
  )
}

/**
 * Section titles
 */
export const H2 = ({ children, className }: TypographyProps) => {
  return (
    <h2
      className={twMerge(
        'font-inter text-3xl md:text-5xl font-light tracking-tight text-gray-900',
        className
      )}
    >
      {children}
    </h2>
  )
}

/**
 * Card / content headers
 */
export const H3 = ({ children, className }: TypographyProps) => {
  return (
    <h3
      className={twMerge(
        'font-inter text-xl md:text-2xl font-normal tracking-tight text-gray-900',
        className
      )}
    >
      {children}
    </h3>
  )
}

/**
 * Subheaders / labels
 */
export const H4 = ({ children, className }: TypographyProps) => {
  return (
    <h4
      className={twMerge(
        'font-inter text-lg md:text-xl font-medium tracking-tight text-gray-900',
        className
      )}
    >
      {children}
    </h4>
  )
}

export const H5 = ({ children, className }: TypographyProps) => {
  return (
    <h5
      className={twMerge(
        'font-inter text-md font-light tracking-tight text-gray-900',
        className
      )}
    >
      {children}
    </h5>
  )
}

/**
 * Body copy
 */
export const Paragraph = ({ children, className }: TypographyProps) => {
  return (
    <p
      className={twMerge(
        'font-inter text-lg md:text-xl font-light leading-relaxed text-gray-900',
        className
      )}
    >
      {children}
    </p>
  )
}
/**
 * Body copy
 */
export const SmallParagraph = ({ children, className }: TypographyProps) => {
  return (
    <p
      className={twMerge(
        'font-inter text-sm md:text-base font-light leading-relaxed text-gray-900',
        className
      )}
    >
      {children}
    </p>
  )
}

/**
 * Meta / captions / overlines
 */
export const SmallText = ({ children, className }: TypographyProps) => {
  return (
    <span
      className={twMerge(
        'font-inter text-xs md:text-sm uppercase tracking-wide text-gray-500',
        className
      )}
    >
      {children}
    </span>
  )
}
